<template>
    <Select
        class="ihlp-c-user"
        v-model="selectData"
        filterable
        clearable
        remote
        :disabled="disabled"
        :multiple="multiple"
        placeholder="请输入工号，再选择"
        :remote-method="remoteMethod"
        :loading="loading"
        :focused="isFocused"
        filterIncludesValue
        @on-blur="onBlur"
        @on-change="userChange">
        <Option v-for="(item,index) in dataList" :value="item.uid" :key="index">{{item.ucn}}</Option>
    </Select>
</template>
<script>
import Select from './select/select.vue';
import Option from './select/option.vue';
import OptionGroup from './select/option-group.vue';
    export default {
        name:"ihlpUser",
        components: {Select,Option,OptionGroup},
        //如果需要userId，传递valueAttr即可
        props: {
            value: {
                type: [String, Array],
                default: ''
            },
            valueAttr: {
                type: String,
                default: "uid"
            },
            multiple: {
                type: Boolean,
                default: false
            },
            //是否是查询我们系统的数据
            isQueryIdataUser: {
                type: [String,Boolean],
                default: false
            },
            //是否开始就获取焦点
            isFocused:{
                type: Boolean,
                default: false
            },
            onChange:{
                type: Function
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                selectData: '',
                loading: false,
                //查询来源，0是本系统，1是idata
                queryFrom:"0",
                dataList: [],
                initValue:'',
                isChangeUser:false
            }
        },
        mounted(){
            this.init()
        },
        methods: {
            init(){
                this.initValue=this.value
                this.selectData=this.multiple?[]:"";
                if(this.initValue){
                    this.initSetData()
                }
            },
            //初始化数据。在服务未调用前，如果设置了数据则会触发该方法。
            initSetData(value) {
                let self = this;
                this.$api.post({
                    sc: "user",
                    url: "userManager/getUserByUUIDStringLocal",
                    params:{
                        "uuidString":self.initValue
                    },
                    success: r => {
                        let list=r.result||[];
                        if(list.length>0){
                            list.filter(item=>{
                                // item.uid=item.userId
                                item.uid=self.valueAttr=="userId"?item.userId:item.uuid
                                //employeeNumber可能没有
                                item.ucn=item.employeeNumber?item.displayname+" "+item.employeeNumber:item.displayname
                            })
                            self.dataList=list
                            self.$nextTick(function(){
                                self.selectData=self.initValue
                                self.userChange(self.initValue)
                            })
                        }
                        
                    }
                })
            },
            remoteMethod (query) {
                let self=this
                //避免选中值的时候再次调用服务，做标识判断一下
                if(self.isChangeUser){
                    self.isChangeUser=false
                    return false
                }
                if (query !== ''&&query.length >=3&&this.initValue=='') {
                    self.loading = true;
                    //console.log("======输入中")
                    self.setStartTime()
                    if(self.myInterval){
                        //console.log("======停止上一个")
                        clearInterval(self.myInterval);
                    }
                    self.myInterval = setInterval(function(){
                        let stopTime=new Date().getTime();
                        if(stopTime-self.startTime>1000){
                            //console.log("======停止了")
                            clearInterval(self.myInterval);
                            self.$api.post({
                                sc:"user",
                                url:'userManager/userListByLikeLocal',
                                params:{
                                    "filter":{"userId":query}
                                },
                                success: r => {
                                    self.queryFrom="0"
                                    //先查自己的表，如果不存在就查idata的服务。如果自己的表有数据，选中某个用户时自动填写类型。
                                    if(r.result&&r.result.length>0){
                                        self.loading = false
                                        let list=r.result||[];
                                        list.filter(item=>{
                                            item.uid=self.valueAttr=="userId"?item.userId:item.uuid
                                            //employeeNumber可能没有
                                            item.ucn=item.employeeNumber?item.displayname+" "+item.employeeNumber:item.displayname?item.displayname:item.uid
                                        })
                                        self.dataList=list
                                    }else if(self.isQueryIdataUser==="true"||self.isQueryIdataUser===true){
                                        self.getIdataUser(query)
                                    }else{
                                        self.loading = false
                                        self.dataList=[]
                                    }
                                    
                                }
                            })
                        }
                    }, 500);
                    
                }else{
                    this.options = [];
                    self.initValue=""
                    return false
                }
            },
            getIdataUser(query){
                let self=this
                self.$api.post({
                    sc:"user",
                    url:'userManager/getUserFromIdataLocal',
                    params:{
                        "filter":{"uid":query}
                    },
                    success: r => {
                        self.loading = false;
                        self.queryFrom="1";
                        let list=[]
                        try {
                            list=JSON.parse(r.result)||[];
                        } catch (error) {
                            console.log("用户数据格式错误。")
                        }
                        self.dataList=list;
                    }
                })
            },
            setStartTime(){
                this.startTime=new Date().getTime()
            },
            userChange(value){
                //如果需要userId，传递valueAttr即可
                let uid=""
                let item={}
                if(value!==undefined)this.isChangeUser=true
                if(value){
                    item=this.getItem(value)
                    uid=this.valueAttr=="userId"?value:item.uuid
                }
                this.$emit('input', uid)
                this.$emit('onChange',uid,item,this.queryFrom)
            },
            getQueryFrom(){
                return this.queryFrom
            },
            getItem(value){
                let item={}
                for(let i=0;i<this.dataList.length;i++){
                    item=this.dataList[i]
                    let uid=this.valueAttr=="userId"?item.uid:item.uuid
                    if(value==uid)break;
                }
                return item
            },
            onBlur(){
                this.$emit('on-blur', this.selectData,this.getItem(this.selectData));
            }
        },
        watch: { 
            value(newValue,oldValue){
                if (newValue === '') {
                    this.selectData = this.multiple ? [] : "";
                }else if (
                    newValue != oldValue &&
                    newValue != this.selectData
                ) {
                    this.init(newValue);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/user.vue